import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetCurrentQuestionAndSettingsRPC } from "./getCurrentQuestionAndSettingsRPC";

export class GetCurrentQuestionAndSettingsRPCClientImpl extends GetCurrentQuestionAndSettingsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetCurrentQuestionAndSettingsRPC.Request): Promise<LeoRPCResult<GetCurrentQuestionAndSettingsRPC.Response, GetCurrentQuestionAndSettingsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-respondent/GetCurrentQuestionAndSettings",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetCurrentQuestionAndSettingsRPC.ResponseDTO,
      GetCurrentQuestionAndSettingsRPC.Errors.ErrorsDTO,
      GetCurrentQuestionAndSettingsRPC.Response,
      GetCurrentQuestionAndSettingsRPC.Errors.Errors
    >(
      response,
      "survey-respondent/GetCurrentQuestionAndSettings",
      GetCurrentQuestionAndSettingsRPC.Response.fromDTO,
      GetCurrentQuestionAndSettingsRPC.Errors.fromDTO
    );
  }
}
